/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteSessionsListServerClientAssociations } from "../funcs/remoteSessionsListServerClientAssociations.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListServerClientAssociationsResult } from "../models/components/listserverclientassociationsresult.js";
import {
  ListServerClientAssociationsRequest,
  ListServerClientAssociationsSecurity,
} from "../models/operations/listserverclientassociations.js";
import { unwrapAsync } from "../types/fp.js";
export type ServerClientAssociationsQueryData =
  ListServerClientAssociationsResult;

export function prefetchServerClientAssociations(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListServerClientAssociationsRequest,
  security?: ListServerClientAssociationsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildServerClientAssociationsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildServerClientAssociationsQuery(
  client$: GramCore,
  request: ListServerClientAssociationsRequest,
  security?: ListServerClientAssociationsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ServerClientAssociationsQueryData>;
} {
  return {
    queryKey: queryKeyServerClientAssociations({
      mcpServerId: request.mcpServerId,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function serverClientAssociationsQueryFn(
      ctx,
    ): Promise<ServerClientAssociationsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteSessionsListServerClientAssociations(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyServerClientAssociations(
  parameters: {
    mcpServerId: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "remoteSessions",
    "listServerClientAssociations",
    parameters,
  ];
}
